import React from 'react';
import './styles.scss';

export type DealStatus = 'Estimate' | 'Draft' | 'Review' | 'Bidding' | 'Diligence' | 'Executed' | 'Deal Completed';

interface DealStatusBadgeProps {
  status: DealStatus;
}

export const DealStatusBadge: React.FC<DealStatusBadgeProps> = ({ status }) => {
  return (
    <span className={`deal-status-badge deal-status-badge--${status?.toLowerCase().replace(/\s+/g, '-')}`}>
      {status}
    </span>
  );
};

export default DealStatusBadge;